import { Autocomplete, Grid, TextField } from '@mui/material'
import React from 'react'

const Structure = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12}>
    <Autocomplete
      options={[
        'Right Bundle Branch Block',
        'Left Bundle Branch Block',
        'Long QT Interval',
        'High Take-Off',
        'Left Axis Deviation',
        'Normal Axis',
        'Right Axis Deviation',
        'Ventricular Hypertrophy',
        'ST-Segment Elevation (STEMI)',
        'ST-Segment Depression',
        'T-Wave Inversion',
        'Short PR Interval',
        'Atrial Enlargement',
        'Delta Wave',
        'Brugada Syndrome'
      ]}
      value={moduleValues?.['Structure'] ?? []}
      onChange={(e, value) =>
        setModuleValues((prev) => ({ ...prev, ['Structure']: value }))
      }
      renderInput={params => <TextField {...params} label='Structure' />}
      multiple
      freeSolo
    />
  </Grid>
)

export default Structure